module.exports = __webpack_public_path__ + "static/media/login-image.e1947c69.png";